import React, { useEffect, useState } from 'react';
{/* ===== Do not remove this IdTokenData =====*/ }
import { IdTokenData } from './DataDisplay';
import { useMsal } from '@azure/msal-react';
import { createClaimsTable } from '../../utils/claimUtils';
import * as action from '../../actions/login';
import * as storage from '../../utils/storage';
import { withCookies, Cookies } from 'react-cookie';
import { login, errorRedirect, errorSSORedirect } from '../../utils/redirect';
import LoginStep2 from './LoginStep2';
import { generateToken } from '../../actions/authentication';
import * as LoginCode from '../../scripts/StatusLoginCode';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';
import { IsEmployeeMode, IsSupervisorMode } from '@users';

const useStyles = makeStyles(() => ({
    divDescription: {
        width: '100%',
        textAlign: 'center',
        marginTop: '50px'
    }
}));

const LoginEntra = (props) => {
    const classes = useStyles();

    /**
     * useMsal is hook that returns the PublicClientApplication instance,
     * that tells you what msal is currently doing. For more, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance } = useMsal();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [email, setEmail] = useState('');
    //const [activeAccount, setActiveAccount] = useState(instance.getActiveAccount());
    const [openLoginStep2, setOpenLoginStep2] = useState(false);
    const [listStep2, setListStep2] = useState([]);

    const intervalWaitSSO = storage.getConfigIntervalWaitSSO() ?? 3000;

    const maxTry = 3;
    let tryLogin = 0;

    useEffect(() => {
        handleLoginEntra();
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            action.loginUserSSO(email, storage.getConnectionString().value)
                .then(result => {
                    console.log(result.statusLogin);
                    switch (result.statusLogin) {
                        case LoginCode.LOGIN_FAILED:
                        case LoginCode.LOGIN_USERLOCKED:
                        case LoginCode.LOGIN_TEMPORARILYUNAVAILABLE:
                        case LoginCode.LOGIN_RESTRICTEDEMPLOYEEHIRED:
                        case LoginCode.LOGIN_PASSWORDFIRSTSETUP:
                        case LoginCode.LOGIN_CHANGEPASSWORD:
                            errorRedirect();
                            break;
                        case LoginCode.LOGIN_SSOUSERNOTLINKED:
                            errorSSORedirect();
                            break;
                        case LoginCode.LOGIN_STEP2:
                            IsEmployeeMode() && handleLoginStep2(result.companies);
                            IsSupervisorMode() && handleLoginStep2(result.worksites);
                            break;
                        case LoginCode.LOGIN_SUCCESSFULL:
                            action.connectApp(props, true);
                            break;
                        default:
                            console.log('%cError', 'color: yellow;');
                            errorRedirect();
                    }
                }).catch((error) => {
                    errorRedirect();
                });
        }
    }, [isAuthenticated]);

    const handleLoginEntra = () => {
        setInterval(() => {
            tryLogin++;

            if (tryLogin <= maxTry) {
                const activeAccount = instance.getActiveAccount();
                if (activeAccount != null) {
                    const tokenClaims = createClaimsTable(activeAccount.idTokenClaims);

                    const emailSSO = tokenClaims.filter(x => x[0] == 'preferred_username')[0][1];

                    setEmail(emailSSO);

                    storage.saveIsSSO(true);

                    setIsAuthenticated(emailSSO.length > 0);
                }
            } else {
                login();
            }
        }, intervalWaitSSO);
    }

    const handleLoginStep2 = (list) => {
        if (IsEmployeeMode()) {
            storage.saveCompanies(list);
        }

        if (IsSupervisorMode()) {
            storage.saveWorksites(list);
        }

        setOpenLoginStep2(true);
        setListStep2(list);
    }

    const handleCloseLoginStep2 = () => {
        setOpenLoginStep2(false);
    }

    const handleOnChangeLoginStep2 = async (value, accessType) => {
        const company = value.split('|')[0];

        const worksite = value.split('|')[1];

        await generateToken(company, worksite, accessType);

        if (result) {
            action.connectApp(props, true);
        } else {
            errorRedirect();
        }
    }

    return (
        <div>
            <LoginStep2 openLoginStep2={openLoginStep2} handleClose={handleCloseLoginStep2} list={listStep2} onChange={handleOnChangeLoginStep2} />

            {!openLoginStep2 && <div className={classes.divDescription}>
                <span>{i18next.t('login:login.message.processRequest')}</span>
            </div>}

            {/* ===== Do not remove this section =====*/}
            {/*activeAccount ? (
                <div className={classes.divDescription}>
                    IF YOU WANT TO SEE THE MICROSOFT LOGIN RETURN <IdTokenData idTokenClaims={activeAccount.idTokenClaims} />
                </div>
            ) : <span>Error</span>*/}
            {/* ===== Do not remove this section =====*/}

        </div>
    )
}

export default withNamespaces(['login'], { wait: true })(withCookies(LoginEntra));